var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zM9.008 6H6.656a.632.632 0 00-.464.192.632.632 0 00-.192.464c0 1.536.299 3.008.896 4.416a11.298 11.298 0 002.432 3.6 11.299 11.299 0 003.6 2.432c1.408.597 2.88.896 4.416.896a.632.632 0 00.464-.192.629.629 0 00.184-.358l.008-.106v-2.352a.632.632 0 00-.192-.464.632.632 0 00-.464-.192c-.875 0-1.664-.123-2.368-.368a.546.546 0 00-.368-.032.624.624 0 00-.252.126l-.068.066-1.472 1.472a10.38 10.38 0 01-2.544-1.872 10.392 10.392 0 01-1.682-2.196l-.19-.348 1.472-1.472a.533.533 0 00.176-.32.852.852 0 00-.016-.368c-.245-.704-.368-1.493-.368-2.368a.632.632 0 00-.192-.464.629.629 0 00-.358-.184L9.008 6z",
    fill: "#223260"
  })));
}
export default SvgPhone;